(() => {
  const GIFT_HANDLE = 'slyo-willkommensgeschenk';
  const readScratch = () => { try { return JSON.parse(localStorage.getItem('slyo_scratch_v1') || '{}'); } catch (e) { return {}; } };
  const fileKey = (src) => { try { const u = new URL(src, location.href); return u.pathname.split('/').pop().replace(/_\d+x\d*(?=\.)/, '').toLowerCase(); } catch (e) { return ''; } };
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: root.dataset.currency || 'EUR' });
    const money = (c) => fmt.format(c / 100);
    const chargerId = root.dataset.chargerId;
    const chargerPrice = Number(root.dataset.chargerPrice || 0);

    /* Galerie */
    const track = root.querySelector('[data-gallery-track]');
    const slides = [...track.children];
    const dotsWrap = root.querySelector('[data-gallery-dots]');
    let current = 0;
    const go = (i) => { current = (i + slides.length) % slides.length; track.scrollTo({ left: track.clientWidth * current, behavior: 'smooth' }); };
    const slideImgs = slides.map((s) => s.querySelector('img'));
    const useThumbs = slides.length > 1 && slideImgs.every(Boolean);
    if (useThumbs) dotsWrap.classList.add('is-thumbs');
    slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Bild ' + (i + 1));
      if (useThumbs) {
        const t = document.createElement('img');
        const src = slideImgs[i].getAttribute('src') || '';
        t.src = src.replace(/([?&]width=)\d+/, '$1160');
        t.alt = ''; t.loading = 'lazy'; t.width = 64; t.height = 64;
        b.appendChild(t);
      }
      b.addEventListener('click', () => go(i));
      dotsWrap.appendChild(b);
    });
    const dots = [...dotsWrap.children];
    const syncDots = () => {
      current = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      const a = dots[current];
      if (useThumbs && a && dotsWrap.scrollWidth > dotsWrap.clientWidth) {
        const target = a.offsetLeft - dotsWrap.clientWidth / 2 + a.offsetWidth / 2;
        if (Math.abs(dotsWrap.scrollLeft - target) > 4) dotsWrap.scrollTo({ left: target, behavior: 'smooth' });
      }
    };
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(syncDots); }, { passive: true });
    syncDots();
    root.querySelector('[data-gallery-prev]').addEventListener('click', () => go(current - 1));
    root.querySelector('[data-gallery-next]').addEventListener('click', () => go(current + 1));
    const slideKeys = slideImgs.map((im) => (im ? fileKey(im.getAttribute('src') || '') : ''));

    /* Einsatzbereiche */
    root.querySelectorAll('[data-use-open]').forEach((btn) => btn.addEventListener('click', () => {
      const d = root.querySelector('[data-use-dialog="' + btn.dataset.useOpen + '"]');
      if (d && d.showModal) d.showModal();
    }));
    root.querySelectorAll('.slyo-dialog').forEach((d) => d.addEventListener('click', (e) => { if (e.target === d || e.target.closest('[data-close]')) d.close(); }));

    /* Bundles & Farben */
    const tiers = [...root.querySelectorAll('[data-tier]')];
    const colors = [...root.querySelectorAll('.slyo-color')];
    const hint = root.querySelector('[data-hint]');
    const countLabel = root.querySelector('[data-color-count]');
    const atc = root.querySelector('[data-atc]');
    const atcTotal = root.querySelector('[data-atc-total]');
    const err = root.querySelector('[data-error]');
    const addon = root.querySelector('[data-addon]');
    const addonInput = root.querySelector('[data-addon-input]');
    const addonPrice = root.querySelector('[data-addon-price]');
    const stickyTotal = root.querySelector('[data-sticky-total]');
    const counts = new Map(colors.map((c) => [c.dataset.variantId, 0]));
    let tier = tiers.find((t) => t.classList.contains('is-active')) || tiers[0];
    let chargerOn = false;
    const sum = () => [...counts.values()].reduce((a, b) => a + b, 0);
    const tierQty = () => Number(tier ? tier.dataset.qty : 1);
    const chargerFree = () => !!tier && tier.dataset.freeCharger === 'true';
    const avail = (c) => c.dataset.available === 'true';

    /* Farbe antippen → passendes Bild in der Galerie zeigen */
    colors.forEach((c) => {
      const im = c.querySelector('img.slyo-color__img');
      if (!im) return;
      const idx = slideKeys.indexOf(fileKey(im.getAttribute('src') || ''));
      if (idx < 0) return;
      c.addEventListener('click', () => { if (window.matchMedia('(max-width: 989px)').matches && track.getBoundingClientRect().bottom < 0) return; go(idx); });
    });

    /* Willkommensgeschenk aus dem Rubbel-Popup */
    const giftOn = !!readScratch().claimed;
    let giftId = null;
    const giftNote = document.createElement('p');
    giftNote.className = 'slyo-giftnote';
    giftNote.hidden = true;
    giftNote.style.cssText = 'margin-top:16px;padding:12px 14px;border-radius:10px;background:#e6f6ec;color:#0b6b35;font-size:14px;font-weight:500;';
    atc.parentNode.insertBefore(giftNote, atc);

    const fillFirst = () => {
      const need = tierQty() - sum();
      if (need <= 0) return;
      const target = colors.find((c) => counts.get(c.dataset.variantId) > 0 && avail(c)) || colors.find(avail);
      if (target) counts.set(target.dataset.variantId, counts.get(target.dataset.variantId) + need);
    };
    const trimToTier = () => {
      let over = sum() - tierQty();
      for (let i = colors.length - 1; i >= 0 && over > 0; i--) {
        const id = colors[i].dataset.variantId;
        const take = Math.min(counts.get(id), over);
        counts.set(id, counts.get(id) - take);
        over -= take;
      }
    };
    const render = () => {
      const q = tierQty(), s = sum();
      colors.forEach((c) => {
        const n = counts.get(c.dataset.variantId);
        const out = c.querySelector('[data-count]');
        out.textContent = n; out.classList.toggle('has-value', n > 0);
        c.querySelector('[data-plus]').disabled = !avail(c) || s >= q;
        c.querySelector('[data-minus]').disabled = n === 0;
      });
      if (countLabel) countLabel.textContent = s + ' / ' + q + ' gewählt';
      if (s < q) { hint.hidden = false; hint.textContent = 'Wähle noch ' + (q - s) + (q - s === 1 ? ' Karte' : ' Karten') + ' – Farben kannst du beliebig mischen.'; }
      else hint.hidden = true;
      if (addon) {
        addon.classList.toggle('is-included', chargerFree());
        addon.classList.toggle('is-on', !chargerFree() && chargerOn);
        addonInput.checked = chargerFree() || chargerOn;
        addonPrice.textContent = chargerFree() ? 'GRATIS' : '+ ' + money(chargerPrice);
      }
      if (giftOn && giftId) {
        giftNote.hidden = false;
        giftNote.textContent = q >= 3 ? '🎁 Deine Gratis-Karte (Schwarz) kommt automatisch mit ins Paket.' : '🎁 Wähle ein Bundle ab 3 Karten, um deine Gratis-Karte zu bekommen.';
      }
      let total = Number(tier ? tier.dataset.price : 0);
      if (addon && chargerOn && !chargerFree()) total += chargerPrice;
      atcTotal.textContent = money(total);
      if (stickyTotal) stickyTotal.textContent = q + (q === 1 ? ' Karte · ' : ' Karten · ') + money(total);
      atc.disabled = s !== q || q === 0;
    };
    const setTier = (t) => {
      if (!t) return;
      tier = t;
      tiers.forEach((x) => { x.classList.toggle('is-active', x === t); x.querySelector('input').checked = x === t; });
      trimToTier(); fillFirst(); render();
    };
    tiers.forEach((t) => t.addEventListener('click', (e) => { e.preventDefault(); setTier(t); }));
    colors.forEach((c) => {
      const id = c.dataset.variantId;
      c.querySelector('[data-plus]').addEventListener('click', () => { if (sum() < tierQty()) { counts.set(id, counts.get(id) + 1); render(); } });
      c.querySelector('[data-minus]').addEventListener('click', () => { if (counts.get(id) > 0) { counts.set(id, counts.get(id) - 1); render(); } });
    });
    if (addon) addon.addEventListener('click', (e) => { e.preventDefault(); if (chargerFree()) return; chargerOn = !chargerOn; render(); });
    const pre = new URLSearchParams(location.search).get('bundle');
    setTier((pre && tiers.find((t) => t.dataset.qty === pre)) || tier);

    if (giftOn) {
      fetch('/products/' + GIFT_HANDLE + '.js').then((r) => (r.ok ? r.json() : null)).then((p) => {
        if (p && p.variants && p.variants[0] && p.variants[0].available) { giftId = p.variants[0].id; render(); }
      }).catch(() => {});
    }

    /* Warenkorb */
    atc.addEventListener('click', async () => {
      if (sum() !== tierQty()) return;
      err.hidden = true; atc.disabled = true;
      const label = atc.querySelector('[data-atc-label]'); const old = label.textContent;
      label.textContent = 'Wird hinzugefügt …';
      const bundle = tierQty() + 'er-Bundle';
      const items = [];
      counts.forEach((n, id) => { if (n > 0) items.push({ id: Number(id), quantity: n, properties: { _bundle: bundle } }); });
      if (chargerId && (chargerFree() || chargerOn)) items.push({ id: Number(chargerId), quantity: 1, properties: chargerFree() ? { _bundle: bundle } : {} });
      if (giftOn && giftId && tierQty() >= 3) items.push({ id: Number(giftId), quantity: 1, properties: { _gift: 'WILLKOMMEN' } });
      try {
        const res = await fetch(root.dataset.addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.description || 'Das hat leider nicht geklappt. Bitte versuch es erneut.'); }
        window.location.href = root.dataset.redirect === 'checkout' ? '/checkout' : root.dataset.cartUrl;
      } catch (e) {
        err.textContent = e.message; err.hidden = false; label.textContent = old; atc.disabled = false;
      }
    });

    /* Lieferdatum */
    const addBD = (d, n) => { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); const w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; };
    const df = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
    const shipEl = root.querySelector('[data-ship-date]');
    if (shipEl) shipEl.textContent = df.format(addBD(new Date(), Number(root.dataset.shipMin))) + ' und ' + df.format(addBD(new Date(), Number(root.dataset.shipMax)));

    /* Sticky */
    const sticky = root.querySelector('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(atc);
      root.querySelector('[data-sticky-btn]').addEventListener('click', () => root.querySelector('.slyo-tiers').scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }
  };
  const boot = () => document.querySelectorAll('.slyo-pdp').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
